import Axios from '@/common/require'
export default {
  // 个人职位
  // 职位列表
  GET_POSITION_LIST(store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url: '/api.php/console/job/index',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
  // 职位数据
  GET_POSITION_COUNT(store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url: '/api.php/console/job/index',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
  //个人删除职位
  DEL_POSITION(store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url: '/api.php/console/job/delete',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
  // 个人职位详情
  GET_POSITION_INFO(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:`/api.php/console/job/info`,
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 个人职位详情更新
  UPDATA_POSITION_INFO(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:`/api.php/console/job/update`,
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 个人职位预览（小程序二维码）
  GET_POSITION_REVIEW(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:`/api.php/console/job/review`,
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 个人职位详情候选人
  GET_POSITION_CANDIDATE_LIST(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:`/api.php/console/job/get_list`,
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 个人职位候选人投递状态更改
  UPDATA_POSITION_CANDIDATES_STATUS(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:`/api.php/console/job/update_status`,
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 个人职位候选人删除
  DELETE_POSITION_CANDIDATE(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:`/api.php/console/job/post_delete`,
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 个人职位候选人详情
  GET_POSITION_CANDIDATE(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:`/api.php/console/job/detail`,
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 职位批量导入
  IMPORT_POSITION(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:`/api.php/console/job/import`,
        data,
        options:{
          method:'post',
          load:1,
          json:0,
          file:1
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 发送面试邀请
  POST_INVITE_MSG(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:`/api.php/console/job/postmsg`,
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 未通过通知
  NOT_PASS(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:`/api.php/console/job/notpass`,
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 职位新建
  CREATE_POSITION_INFO(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:`/api.php/console/job/create`,
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 职位新建 下拉数据
  GET_SELECT_LIST(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:`/api.php/api/index/job_select`,
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },


  // 全部职位
  // 全部职位列表
  GET_JOBS_LIST(store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url: '/api.php/console/jobs/index',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
  // 批量导入
  IMPORT_JOBS(store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url: '/api.php/console/jobs/import',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0,
          file: 1
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
  // 批量删除
  DEL_JOBS(store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url: '/api.php/console/jobs/delete',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
  // 职位预览
  GET_JOBS_REVIEW(store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url: '/api.php/console/jobs/review',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
  // 职位新建
  CREATE_JOBS_INFO(store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url: '/api.php/console/jobs/create',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
  // 职位更新
  UPDATA_JOBS_INFO(store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url: '/api.php/console/job/update',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
  // 全部职位详情
  GET_JOBS_INFO(store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url: '/api.php/console/jobs/info',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
  // 全部职位详情候选人
  GET_JOBS_CANDIDATE_LIST(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:`/api.php/console/jobs/get_list`,
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 全部职位候选人投递状态更改
  UPDATA_JOBS_CANDIDATES_STATUS(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:`/api.php/console/jobs/update_status`,
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 全部职位候选人删除
  DELETE_JOBS_CANDIDATE(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:`/api.php/console/jobs/post_delete`,
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 全部职位候选人详情
  GET_JOBS_CANDIDATE(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:`/api.php/console/jobs/detail`,
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 全部职位候选人面试邀请
  POST_JOBS_INVITE_MSG(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:`/api.php/console/jobs/postmsg`,
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },
  // 全部职位  未通过通知
  NOT_PASS_JOBS(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url:`/api.php/console/jobs/notpass`,
        data,
        options:{
          method:'post',
          load:1,
          json:0
        }
      }).then(dt=>{
        resolve(dt)
      })
    })
  },





  // 候选人
  // 我的候选人列表
  GET_CANDIDATE_LIST(store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url: '/api.php/console/candidate/index',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
  DEL_CANDIDATE(store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url: '/api.php/console/candidate/delete',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
  // 候选人状态更新
  UPDATA_CANDIDATE_STATUS(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url: '/api.php/console/candidate/update_status',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
  // 我的候选人详情
  GET_CANDIDATE_DETAIL(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url: '/api.php/console/candidate/detail',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
  // 所有候选人
  GET_CANDIDATES_LIST(store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url: '/api.php/console/candidates/index',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
  DEL_CANDIDATES(store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url: '/api.php/console/candidates/delete',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
  // 所有候选人状态更新
  UPDATA_CANDIDATES_STATUS(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url: '/api.php/console/candidates/update_status',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
  // 所有候选人详情
  GET_CANDIDATES_DETAIL(store, data){
    return new Promise((resolve,reject)=>{
      Axios({
        url: '/api.php/console/candidate/detail',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },

  // 用户管理列表
  GET_USERS_LIST(store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url: '/api.php/console/users/index',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  },
  // 用户管理详情
  GET_USERS_DETAIL(store,data){
    return new Promise((resolve,reject)=>{
      Axios({
        url: '/api.php/console/users/detail',
        data,
        options: {
          method: 'post',
          load: 1,
          json: 0
        }
      }).then(dt=>{
        resolve(dt);
      })
    })
  }
  


  
}


// WEBPACK FOOTER //
// ./src/store/modules/recruit/actions.js